var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-select',{attrs:{"multiple":true,"data-title":'Redes',"data-menu-heading":'Redes',"data-button-gradient":true,"data-items":_vm.formattedList},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }